@let config = config$ | async;
@let state = state$ | async;

@if (config && state && isVisible(state, config)) {
    <div
        class="progress-overlay"
        [class.completed]="state.status === 'completed'"
        [class.minimal]="config.minimal">
        <div class="progress-overlay__card">
            <h4 class="progress-overlay__title gup-O-titrage__title">{{ config.title }}</h4>

            @if (config.subtitle) {
                <p class="progress-overlay__subtitle">{{ config.subtitle }}</p>
            }

            @if (!config.minimal && config.steps.length > 1) {
                <div class="progress-overlay__steps">
                    @for (step of config.steps; track step.id; let i = $index) {
                        <app-progress-step
                            [label]="step.label"
                            [state]="getStepState(i, state)"
                            [details]="i === state.currentStepIndex ? state.details : null" />
                    }
                </div>
            }

            <kal-progress-bar
                [value]="state.overallProgress"
                color="orange" />

            <div class="progress-overlay__percent">
                {{ state.overallProgress | number:'1.0-0' }}%
            </div>

            @if (config.minimal && state.details) {
                <p class="progress-overlay__details">{{ state.details }}</p>
            }

            @if (state.status === 'error' && state.errorMessage) {
                <div class="progress-overlay__error gup-O-msg -error">
                    {{ state.errorMessage }}
                </div>
            }
        </div>
    </div>
}
